import {Injectable} from "@angular/core";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import * as EcommerceGeneralSettingsAction from '../actions/ecommerce-general-settings.action';
import {DbResponse} from "../../shared/interceptors/db-response";
import {filter, map, mergeMap} from 'rxjs/operators';
import {LoadEcommerceGeneralSettings} from "../actions";
import {EcommerceService} from "../../websites/website/ecommerce/ecommerce.service";

@Injectable()
export class EcommerceGeneralSettingsEffect {

  loadEcommerceGeneralSettings = createEffect(() => this._actions$.pipe(
    ofType(EcommerceGeneralSettingsAction.LOAD_ECOMMERCE_GENERAL_SETTINGS),
    mergeMap((action: LoadEcommerceGeneralSettings) => {
      const {websiteId} = action.payload;
      return this._ecommerceService.getGeneralSettings(websiteId)
        .pipe(
          filter((response: DbResponse) => !!response),
          map((response: DbResponse) => {
            if (response.success && response?.data) {
              return new EcommerceGeneralSettingsAction.LoadEcommerceGeneralSettingsSuccess({
                data: response?.data?.dataKey,
                websiteId: websiteId,
                loaded: true
              });
            }
            return new EcommerceGeneralSettingsAction.LoadEcommerceGeneralSettingsFail({websiteId});
          })
        );
    })
  ));



  constructor(
    private _actions$: Actions,
    private _ecommerceService: EcommerceService,
  ) {
  }

}
